// extracted by mini-css-extract-plugin
export default {"subcategoriesRow":"p_bs","subcategoryColumn":"p_bt","articleLink":"p_bv","articleCoverImage":"p_bw","articleTitle":"p_bx","articleMetaDescription":"p_bG"};